import { useEffect, useState } from 'react';
import { Typography } from '../../typography';
import { Button } from '../../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from '../ModalComponents';
import { useExtendDateGateOutMutation } from '../../../hooks';
import { enqueueSnackbar } from '../../snackbar';
import { MESSAGES } from '../../../const';
import { i18n } from '../../../i18n';
import { DatePicker } from '../../input';
import moment from 'moment';

interface GateExtendDateModalType {
  ids: string[];
  numbers: string[];
  submitClick: () => void;
  open: () => void;
}

export const gateExtendDateModal: GateExtendDateModalType = {
  ids: [],
  numbers: [],
  submitClick: () => null,
  open: () => null,
};

export const GateExtendDateModal = () => {
  const gateOutExtendDateMutation = useExtendDateGateOutMutation();
  const [open, setOpen] = useState(false);
  const [validTo, setValidTo] = useState(moment());

  useEffect(() => {
    gateExtendDateModal.open = () => {
      setValidTo(moment());
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    gateExtendDateModal.ids = [];
    gateExtendDateModal.numbers = [];
    setOpen(false);
  };

  const handleSubmitClick = async () => {
    const onSuccess = () => {
      handleOnClose();
      gateExtendDateModal.submitClick();
    };

    gateOutExtendDateMutation.mutate(
      { ids: gateExtendDateModal.ids, validTo },
      {
        onSuccess,
        onError: () => {
          enqueueSnackbar(MESSAGES.GATE_OUT.ERROR.NOT_EDITED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'gate-extend-date-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.gateExtendDateTitle')}
        </Typography>
        <DatePicker
          label={i18n.t('label.to')}
          data-size={'medium'}
          defaultValue={validTo}
          onChange={setValidTo}
          minDate={moment()}
        />
        {gateExtendDateModal.numbers.map((number, i) => (
          <Typography key={i} variant={'textM'}>
            {number}
          </Typography>
        ))}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
